export default __webpack_public_path__ + "static/13-medication-a932e7673e09038a881472a3326111b9.png";